import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import "./EventCard.css";
import { Link } from "react-router-dom";
import { useData } from "../../providers/dataProvider";

export default function EventCard({ event }) {
  // Destructure the event object
  const { month, day, title, location, short_description, image_id } = event;
  const { images, imagesLoading } = useData();

  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getImageUrl = async () => {
      if (image_id) {
        setLoading(true);
        try {
          const image = images.find((i) => i.id === image_id);
          setImageUrl(image.aws_location);
        } catch (error) {
          console.error("Error loading image:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    getImageUrl();
  }, [image_id, images]);

  if (loading || imagesLoading) {
    return (
      <Card className="event-card">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "200px" }}
        >
          <Spinner animation="border" />
        </div>
      </Card>
    );
  }

  return (
    <Link to={`/event/${event.id}`} className="event-link">
      <Card className="event-card">
        <div className="position-relative bg-white image-container">
          <Card.Img
            variant="top"
            src={imageUrl}
            alt={title}
            className="event-image"
            style={{ height: "150px", objectFit: "scale-down" }}
          />
          {/* Date indicator (left side) */}
          <div
            className="position-absolute d-flex flex-column align-items-center justify-content-center date-indicator"
            style={{
              top: "10px",
              left: "10px",
              width: "45px",
              height: "55px",
              borderRadius: "8px",
              zIndex: "1",
            }}
          >
            <div
              className="small text-uppercase fw-bold text-white"
              style={{ paddingTop: "3px", fontSize: "0.65rem" }}
            >
              {month}
            </div>
            <div className="fs-5 fw-bold text-white">{day}</div>
          </div>
        </div>

        <Card.Body className="p-3">
          <Card.Title className="fs-5 fw-bold mb-2 text-white">
            {title}
          </Card.Title>
          <Card.Text className="mb-2 location-text" style={{ fontSize: "0.9rem" }}>
            {location}
          </Card.Text>
          <div
            className="d-flex align-items-center"
            style={{ fontSize: "0.9rem" }}
          >
            <div
              className="description-dot rounded-circle me-2"
              style={{ width: "6px", height: "6px" }}
            ></div>
            <span className="description-text">{short_description}</span>
          </div>
        </Card.Body>
      </Card>
    </Link>
  );
}
